module.exports = __webpack_public_path__ + "img/30-day-launch.d1b79399.png";